@if (loadingService.loading()) {
  <div class="overlay">
    <div class="progress-container">
      <div class="progress-bar"></div>
    </div>
  </div>
}
